<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">
          <a v-if="$route.meta.showBack" @click="$router.back()" href="#">
            <md-icon>arrow_back_ios</md-icon>
          </a>
          <router-link v-if="$route.meta.parentPath" :to="$route.meta.parentPath">
            <md-icon>arrow_back_ios</md-icon>
          </router-link>
          <md-icon v-else-if="$route.meta.icon">{{ $route.meta.icon }}</md-icon>
            <template v-if="$route.params.id">
                {{ $t('pages.'+$route.name,{id:$route.params.id}) }}
            </template>
            <template v-else>
                {{ $t('pages.'+$route.name) }}
            </template>
        </h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="top-user-link topup-balance" v-if="$store.getters.config.registration_activation">
            <span class="">{{ $t('balance') }} {{ balance }} {{ currency }}</span>
            <button class="topup-balance-btn md-button md-primary" @click="showDialog = true">
              <md-icon>add_circle_outline</md-icon>
            </button>
          </div>
          <span class="top-user-link" v-else>{{ $t('balance') }} {{ balance }} {{ currency }}</span>
          <div class="top-user-link">{{ $store.getters.username }}</div>
          <md-button id="button_logout" class="md-button md-theme-default md-simple md-sm" @click="doLogout()">
              {{$t('logout')}}
            <md-icon>logout</md-icon>
          </md-button>
        </div>
      </div>
      <top-up-dialog :show.sync="showDialog" v-if="$store.getters.config.registration_activation" />
    </div>
  </md-toolbar>
</template>

<script>
import TopUpDialog from '@/components/Finances/TopUpDialog.vue';

export default {
  components: {
    TopUpDialog
  },
  data() {
    return {
      balance: "",
      currency: "",
      is_in_progress: false,
      timerId: undefined,
      showDialog: false
    }
  },
  created() {
    this.getBalance()
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    async getBalance() {
      const res = await this.$store.dispatch('getBalance')
      this.balance = res.data.balance
      this.currency = res.data.currency
      this.is_in_progress = res.data.is_in_progress

      if (this.is_in_progress && !this.timerId) {
        this.timerId = setInterval(() => this.getBalance(), 600000)
      }
      if (!this.is_in_progress && this.timerId) {
        clearInterval(this.timerId)
        this.timerId = undefined
      }
    },
    async doLogout() {
      await this.$store.dispatch('authLogout')
      this.$router.push('/login')
    }
  }
};
</script>

<style>
  .md-toolbar .md-collapse {
    align-items: center;
  }
  .top-user-link {
    padding: 0 1.25rem !important;
  }
  .topup-balance {
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #339999;
    border-radius: 25px;
    padding: 0 1.7rem 0 0.7rem!important;
    height: 2rem;
  }
  .topup-balance span {
    padding-right: 2rem;
  }
  .topup-balance-btn {
    position: absolute !important;
    right: -2px!important;
    height: 2rem!important;
    width: 3rem!important;
    min-width: 3rem!important;
    border-radius: 50px!important;
  }
  .topup-balance-btn .md-icon {
    font-size: 1.9rem!important;
  }
</style>